<div class="platform_landing">
  <header class="platform_landing_header">
    <div class="logo">
      <span class="logo_mark"></span>
      <span class="logo_text" (click)="toggleOrbit()">{{ companyName }}</span>
    </div>
    <div class="meta meta--logout" (click)="logout()" title="Log out" role="button" tabindex="0">
      <div class="meta_title">Welcome back</div>
      <div class="meta_user">{{ displayName }}</div>
    </div>
  </header>

  <section class="shelf">
    <div class="shelf_card">
      <div class="shelf_label">Featured</div>
      <h1>SureSIM Control</h1>
      <p>
        Platform mode dashboard...
      </p>
      <div class="shelf_chips">
        <span class="chip">Live</span>
        <span class="chip">Secure</span>
        <span class="chip">Realtime</span>
      </div>
    </div>
    <div class="shelf_art" [class.shelf_art--orbit]="orbit">
      <div class="orb orb--three orb--sun"></div>
      <div class="shelf_orbit">
        <div class="orb orb--one"></div>
        <div class="orb orb--two"></div>
        <img
          class="shelf_logo"
          src="assets/images/SureSIM-Logo-Light-109.png"
          alt="SureSIM"
        />
      </div>
    </div>
  </section>

  <section class="row">
    <h2>Lifecycle Processes</h2>
    <div class="tiles">
      <div class="tile tile--wide" tabindex="0">
        <div class="tile_eyebrow">Device</div>
        <div class="tile_title">Inventory</div>
        <div class="tile_meta">Manage Devices</div>
      </div>
      <div class="tile" tabindex="0">
        <div class="tile_eyebrow">Device</div>
        <div class="tile_title">Orders</div>
        <div class="tile_meta">Device Ordering</div>
      </div>
      <div class="tile" tabindex="0">
        <div class="tile_eyebrow">Device</div>
        <div class="tile_title">Quotes</div>
        <div class="tile_meta">Hardware Quotes</div>
      </div>
      <div class="tile" tabindex="0">
        <div class="tile_eyebrow">Device</div>
        <div class="tile_title">End of Life</div>
        <div class="tile_meta">EOL & Disposal</div>
      </div>
    </div>
  </section>

  <section class="row">
    <h2>Platform</h2>
    <div class="tiles tiles--compact">
      <div class="tile" tabindex="0">
        <div class="tile_eyebrow">Portal</div>
        <div class="tile_title">Inview</div>
        <div class="tile_meta">Customer Management</div>
      </div>
      <a class="tile" tabindex="0" [routerLink]="[dashboardUrl]">
        <div class="tile_eyebrow">Portal</div>
        <div class="tile_title">SureSIM</div>
        <div class="tile_meta">Mobile Provisioning</div>
      </a>
      <div class="tile" tabindex="0">
        <div class="tile_eyebrow">Portal</div>
        <div class="tile_title">MDM Data</div>
        <div class="tile_meta">Device Management</div>
      </div>
      <div class="tile" tabindex="0">
        <div class="tile_eyebrow">Portal</div>
        <div class="tile_title">Reports</div>
        <div class="tile_meta">Inview, SureSIM & MDM Reporting</div>
      </div>
    </div>
  </section>

  <section class="row">
    <h2>Resources</h2>
    <div class="tiles tiles--compact">
      <div class="tile" tabindex="0">
        <div class="tile_eyebrow">Human</div>
        <div class="tile_title">Finance</div>
        <div class="tile_meta">Financial Management</div>
      </div>
      <div class="tile" tabindex="0">
        <div class="tile_eyebrow">Human</div>
        <div class="tile_title">People</div>
        <div class="tile_meta">Access & Roles</div>
      </div>
      <div class="tile" tabindex="0">
        <div class="tile_eyebrow">Human</div>
        <div class="tile_title">Data</div>
        <div class="tile_meta">Corporate</div>
      </div>
      <div class="tile" tabindex="0">
        <div class="tile_eyebrow">Human</div>
        <div class="tile_title">Contracts</div>
        <div class="tile_meta">Legal Managment</div>
      </div>
    </div>
  </section>
</div>
